import Vue from 'vue'
// import EventRootData from './EventRootData'
import EventUser from './EventUser'
import EventAct from './EventAct'
import EventLottery from './EventLottery'
import {ACT_NOT_INIT, ACT_RUNNING} from '../constant/act_stat'
import {isAndroid} from '../tools/mgtv/env'

const EventBus = new Vue({
    data: {
      act: {
        act_stat: window.rootdata.need_act ? ACT_NOT_INIT : ACT_RUNNING,
        ext: {}
      },
      tpl: null, //模板组件
      user: {
        uuid: null,
        vip_id: -1,
        nickname: "游客",
        avatar: "https://vipcdn.mgtv.com/upload/20180417/avatar.png",
        user_type: -1, // 0会员用户(有首冲，且是会员)　1新用户（无首冲）　2会员老用户（有首冲非会员）
        level: 0 ,//会员等级
        mobile:''
      },
      device_info: {
        appVersion: '6.9.9_vipact',
        mac: '0000-0000-0000',
        did: '0000-0000-0000',
        osType: isAndroid() ? 'android' : 'ios'
      },
      channel_chooser: {
        show: false,
      },
      lottery: {
        remain_chance: 0,
        history_dialog_show: false, //当中奖记录弹窗出现时设置为true,消失时为false,不控制弹窗，只是一个全局状态，用来控制用户提交信息时是否刷新中奖记录
        lottery_history: []
      },
      rootdata: window.rootdata
    },
    computed: {}
  })
;

EventBus.$useEvent = function (EventPlugin) {
  if (!EventPlugin) {
    throw new Error("事件插件不能为空");
  }
  if (!EventPlugin.install) {
    throw new Error("事件插件需要实现install方法");
  }
  EventPlugin.install(EventBus);
}

EventBus.$useEvent(EventUser);
EventBus.$useEvent(EventAct);
EventBus.$useEvent(EventLottery);



window.$bus = EventBus;




// WEBPACK FOOTER //
// ./src/EventBus/index.js